import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'

import RadioInput from 'LuxKit/Radio/RadioInput'
import type { FlightDropdownOption as SelectOption } from 'components/Flights/types'
import { rem } from 'polished'
import styled from 'styled-components'
import Caption from 'LuxKit/Typography/Caption'
import Group from 'components/utils/Group'

const NewLabel = styled.span`
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.palette.highlight.secondary.lightBackground};
  color: ${props => props.theme.palette.highlight.secondary.normalForeground};
  padding: 0 ${rem(2)};
  border-radius: ${props => props.theme.borderRadius.S};
  font-weight: ${props => props.theme.font.primary.weight.bold};
  font-size: ${rem(10)};
  line-height: ${rem(13)};
`

// TODO: Replace with design system Tag
const InfoTag = styled(Caption)`
  padding: ${rem(2)} ${rem(8)};
  background-color: ${props => props.theme.palette.neutral.default.six};
  color: ${props => props.theme.palette.neutral.default.one};
  border: 1px solid ${props => props.theme.palette.neutral.default.eight};
  border-radius: ${props => props.theme.borderRadius.S};
`

interface Props {
  defaultChecked?: boolean
  checked?: boolean
  option: SelectOption
  name: string
  onChange: (option: SelectOption) => void
  disabled?: boolean
}

function FlightDropdownOption(props: Props) {
  const {
    defaultChecked,
    checked,
    option,
    onChange,
    name,
  } = props

  const intl = useIntl()

  const onDropdownChange = useCallback(() => {
    onChange(option)
  }, [onChange, option])

  return (
    <RadioInput
      defaultChecked={defaultChecked}
      checked={checked}
      onChange={onDropdownChange}
      name={name}
      value={option.value}
      data-testid={option.value}
      disabled={option.disabled}
    >
      <Group direction="horizontal" horizontalAlign="space-between">
        <Group direction="horizontal" verticalAlign="center" gap="0 4">
          <span>{option.label}</span>
          {option.isNew && <NewLabel>{intl.formatMessage({
            id: 'THsIzidmc/',
            defaultMessage: 'NEW',
            description: 'Badge label for new flight sorting option in the flights flow',
          })}
          </NewLabel>}
        </Group>

        {option.comingSoon && <InfoTag variant="medium" weight="bold" wrap="no-wrap">{intl.formatMessage({
          id: 'CStomrjC1Q',
          defaultMessage: 'Coming soon!',
          description: 'Tag label for upcoming flight sorting option that is not yet available',
        })}
        </InfoTag>}
      </Group>
    </RadioInput>
  )
}

FlightDropdownOption.displayName = 'FlightDropdownOption'

export default FlightDropdownOption
